'use client';
import { useRouter, useSearchParams, usePathname } from 'next/navigation';
import * as React from 'react';

export const useSetQueryParam = (queryKey: string | string[]) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  return React.useCallback(
    (value: any, clearParams?: boolean) => {
      const params = new URLSearchParams(clearParams ? '' : searchParams?.toString() || '');

      if (typeof queryKey === 'string') {
        if (!value) {
          params.delete(queryKey);
        } else {
          params.set(queryKey, value);
        }
      } else {
        queryKey.forEach((key, idx) => {
          if (!value[idx]) {
            params.delete(key);
          } else {
            params.set(key, value[idx]);
          }
        });
      }

      const newUrl = params.toString() ? `${pathname}?${params.toString()}` : pathname || '/';
      router.push(newUrl);
    },
    [router, searchParams, pathname, queryKey]
  );
};
